import { useCallback, useMemo } from 'react';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderContext } from '../../../../providers/OrderProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const ContractModal = ({ setIsOpenPendingModal, isOpenPendingModal }) => {
	const { order, isLoading } = useOrderContext();
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	const contractStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.default ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={contractStatusBadge ? [contractStatusBadge] : []}
			/>

			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					pendingFocus='contract'
					notesType='delivery'
					showOrderProgress
					contractTooltipId='contract-modal-contract-toggle-tooltip'
					invoiceTooltipId='contract-modal-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter />
		</OrderFullscreenModal>
	);
};

export default ContractModal;
